export default __webpack_public_path__ + "01f742ff252a2de37d6b50ac1ac9866f.svg";